import type { MeWorkspace } from '@/api/services/me';

/** Workspaces selectable in the sidebar switcher (defensive client filter). */
export function isVisibleWorkspace(workspace: MeWorkspace): boolean {
  if (workspace.scope === 'personal' || workspace.id == null) {
    return true;
  }
  if (workspace.deletedAt) {
    return false;
  }
  const status = (workspace.status ?? 'active').toLowerCase();
  return status !== 'deleted' && status !== 'archived';
}

export function filterVisibleWorkspaces(workspaces: MeWorkspace[]): MeWorkspace[] {
  return workspaces.filter(isVisibleWorkspace);
}
